import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const AndamanPage = () => {
  return <DestinationTemplate destinationId="andaman" />;
};

export default AndamanPage;
